import React from 'react';
import { useIsMobile } from '../hooks/useIsMobile';
const UsagePage: React.FC = () => {
  const isMobile = useIsMobile();
  return (
    <div className="usage-page">

      <section className="py-5" style={{ width: '100%' }}>
        <img src={'/img/phone/24.jpg'} style={{ width: '100%' }} alt="spacing" className="img-fluid" />
      </section>
    </div>
  );
};

export default UsagePage;
